/**
 * Angular imports
 */
import {Injectable} from 'angular2/core';
import {Http, Headers, Request, RequestOptionsArgs, Response, ConnectionBackend, RequestOptions} from 'angular2/http';

/**
 * Node module imports
 */
import {Observable} from 'rxjs/Observable';

/**
 * Service imports
 */
import {KeycloakService} from './keycloak.service';

/**
 Proxy class to handle 403 error from server and redirect to login page.
 */
@Injectable()
export class CustomHttp extends Http {

    /**
     * @constructor
     * @param {ConnectionBackend} _backend
     * @param {RequestOptions} _defaultOptions
     * @param {KeycloakService} _keycloakService
     */
    constructor(_backend: ConnectionBackend,
                _defaultOptions: RequestOptions,
                private _keycloakService: KeycloakService) {
        super(_backend, _defaultOptions);
    }


    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, this.getRequestOptionArgs(options));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.get(url, this.getRequestOptionArgs(options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.post(url, body, this.getRequestOptionArgs(options));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.put(url, body, this.getRequestOptionArgs(options));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.delete(url, this.getRequestOptionArgs(options));
    }

    patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.patch(url, body, this.getRequestOptionArgs(options));
    }

    head(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.head(url, this.getRequestOptionArgs(options));
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        if (this._keycloakService.getToken()) {
            options.headers.append('Authorization', `Bearer ${this._keycloakService.getToken()}`);
        }

        return options;
    }
}
